module.exports = __webpack_public_path__ + "static/img/number_01@2x.b6ca121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/brandOperation/serviceContent/number_01@2x.png
// module id = 917b
// module chunks = 0